import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import ActionZone from 'components/ActionZone/ActionZone';

import { Box } from '@chakra-ui/react';

import { useLazyGetTemplateByIdQuery } from 'modules/templates/templatesApi';

const TemplateEditorCTA = ({ templateID, campaignValues, editID }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [template, setTemplate] = useState(null);

  const [getTemplateById] = useLazyGetTemplateByIdQuery();

  useEffect(() => {
    if (!templateID) {
      setTemplate(null);
      return;
    }

    const fetchTemplate = async () => {
      try {
        const templateData = await getTemplateById(templateID).unwrap();
        setTemplate(templateData);
      } catch (err) {
        console.error('Failed to fetch template for editor', err);
        setTemplate(null);
      }
    };

    fetchTemplate();
  }, [templateID, getTemplateById]);

  const referrer = `/campaigns/${editID || 'new'}`;
  const params =
    template && template.id !== 0
      ? `?id=${template.id}&ref=${referrer}`
      : `?ref=${referrer}`;

  return (
    <Box
      className="cmp-details__ad-template-editor-cta"
      onClick={() => {
        navigate(`/template-editor${params}`, {
          state: {
            from: location?.state?.from
              ? location.state.from
              : location.pathname === '/campaigns/new'
              ? 'campaigns-new'
              : 'campaigns',
            campaignValues: campaignValues,
          },
        });
      }}
    >
      <ActionZone
        text={
          campaignValues.adTemplate !== 0
            ? 'Edit this template'
            : 'Build your template'
        }
      />
    </Box>
  );
};

export default TemplateEditorCTA;
